import { Box } from "@mui/material";
import { ButtonGroup } from "react-bootstrap";

import { useLoadProductPclCountsQuery } from "api/public/project/product/product.api";

import { usePclContext } from "../../context/PclContextProvider";

import HeaderInfoButton from "./HeaderInfoButton";

const HeaderInfo = () => {
  const { data: pclCounts, isLoading } = useLoadProductPclCountsQuery();
  const {
    filters: { status },
    form,
  } = usePclContext();

  let title = "";
  const {
    certified = 0,
    in_evaluation = 0,
    archived = 0,
    total = 0,
  } = pclCounts || {};

  if (status === "Certified") {
    title = `Product Compliant List - ${certified ?? ""}`;
  }

  if (status === "In Progress") {
    title = `Products In Evaluation - ${in_evaluation ?? ""}`;
  }

  if (status === "Archived") {
    title = `Archived Products - ${archived ?? ""}`;
  }

  if (!status) {
    title = `All Products - ${total}`;
  }

  return (
    <Box
      padding={5}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <h3 className="fw-bold text-primary text-uppercase">{title}</h3>

      <ButtonGroup>
        <HeaderInfoButton
          active={status === "Certified"}
          label={"Product Compliant List"}
          count={certified}
          isLoading={isLoading}
          onClick={() => form.setFieldValue("status", "Certified")}
        />

        <HeaderInfoButton
          active={status === "In Progress"}
          label={"Products In Evaluation"}
          count={in_evaluation}
          isLoading={isLoading}
          onClick={() => form.setFieldValue("status", "In Progress")}
        />

        <HeaderInfoButton
          active={status === "Archived"}
          label={"Archived Products"}
          count={archived}
          isLoading={isLoading}
          onClick={() => form.setFieldValue("status", "Archived")}
        />
      </ButtonGroup>
    </Box>
  );
};
export default HeaderInfo;
